import React from 'react'
import ExpansionPanel from './ExpansionPanel'
import General from './Info'
import Form from './FormInfo'
import Logo from './Logo'
import LandingPage from './LandingPage'
import Groups from './Groups'
import language from 'utils/vast-languagepack'
// import SectionsAndFields from './SectionsAndFields'

const GroupsComponent = () => <Groups minHeight={400} />

const general = {
  Component: General,
  toolTip: language.signupform.add.toolTips.form,
  heading: 'FORM',
  fields: ['formName'],
}

const form = {
  Component: Form,
  heading: 'LOOK AND FEEL',
  toolTip: language.signupform.add.toolTips.lookAndFeel,
  fields: [
    'embedType',
    'title',
    'titleTextColor',
    'description',
    'descriptionTextColor',
    'font',
    'textColor',
    'backgroundColor',
    'buttonText',
    'buttonTextColor',
    'buttonBackgroundColor',
  ],
}

const logo = {
  Component: Logo,
  heading: language.signupform.add.header.logo,
  toolTip: language.signupform.add.toolTips.logo,
  fields: ['logoURL'],
}

const landingPage = {
  Component: LandingPage,
  heading: 'LANDING PAGE',
  toolTip:
    'Here you can change what the form displays once it has been submitted.',
  fields: ['landingPageContent', 'landingPageURL'],
}

const groups = {
  Component: GroupsComponent,
  heading: 'GROUPS',
  toolTip: 'Select the groups you would like these contacts to be added to',
  fields: [],
}

// const sectionsAndFields = {
// 	Component: SectionsAndFields,
// 	heading: 'SECTIONS AND FIELDS',
// 	toolTip: 'Sections and Fields',
// 	fields: [],
// }

export default ({ formTypeSelected }) => {
  const drawerObj = {
    custom: [general, /* sectionsAndFields, */ groups, form, logo, landingPage],
    customIntegration: [general],
    signup: [general, groups, form, logo],
  }

  const arr = drawerObj?.[formTypeSelected] || []

  return (
    <div style={{ padding: '0px 10px 0px 10px' }}>
      {arr.map((obj, idx) => {
        const { heading, Component, fields, toolTip } = obj
        return (
          <ExpansionPanel
            arrLength={arr?.length}
            key={`expansionPanel${heading}`}
            heading={heading}
            idx={idx}
            fields={fields}
            toolTip={toolTip}
          >
            <Component />
          </ExpansionPanel>
        )
      })}
    </div>
  )
}
